import {lazy} from 'react';

export const EventsFilterLazy = lazy(() => import(/* webpackChunkName: "eventsFilter" */ '.'));
